import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SupplementShopOrderView } from "src/components/views/erp/production/supplementShopOrder/SupplementShopOrderView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/production/supplementShopOrder")({
	staticData: { title: i18n.t("supplement_shop_order"), legacyViewKey: "supplementShopOrderPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SupplementShopOrderView />;
}
